import React from "react";
import FirstPage from "./FirstPage";
import "./styles.css";
import SecondPage from "./SecondPage";
import ThirdPage from "./ThirdPage";
import FourthPage from "./FourthPage";
import FifthPage from "./FifthPage";
import SixthPage from "./SixthPage";
import SeventhPage from "./SeventhPage";
import Footer from "./Foooter";

function Home() {
  return (
    <>
      <div className="">
        <FirstPage />
        <SecondPage />
        <ThirdPage />
        <FourthPage />
        <FifthPage />
        <SixthPage />
        <SeventhPage />
        <Footer />
      </div>
    </>
  );
}

export default Home;
